import { defineMessages } from 'react-intl'

const scope = `procurify.hooks.useFormatOrderItemStatus`

export default defineMessages({
  statusPending: {
    id: `${scope}.statusPending`,
    defaultMessage: 'Pending',
  },
  statusApproved: {
    id: `${scope}.statusApproved`,
    defaultMessage: 'Approved',
  },
  statusRejected: {
    id: `${scope}.statusRejected`,
    defaultMessage: 'Rejected',
  },
  statusPurchased: {
    id: `${scope}.statusPurchased`,
    defaultMessage: 'Purchased',
  },
  statusDenied: {
    id: `${scope}.statusDenied`,
    defaultMessage: 'Denied',
  },
  statusReceived: {
    id: `${scope}.statusReceived`,
    defaultMessage: 'Received',
  },
  statusDraft: {
    id: `${scope}.statusDraft`,
    defaultMessage: 'Draft',
  },
  statusPendingPurchase: {
    id: `${scope}.statusPendingPurchase`,
    defaultMessage: 'Pending Purchase',
  },
  statusPartiallyReceived: {
    id: `${scope}.statusPartiallyReceived`,
    defaultMessage: 'Partially Received',
  },
  punchOutOrderCancelled: {
    id: `${scope}.punchOutOrderCancelled`,
    defaultMessage: 'Order Canceled',
  },
  punchOutPartiallyPurchased: {
    id: `${scope}.punchOutPartiallyPurchased`,
    defaultMessage: 'Partially Purchased',
  },
})
